// @flow
import React, { forwardRef } from 'react';
import { Button } from 'semantic-ui-react';
import { Spinner, Fireworks, Footer } from 'components';
import { isAppleDevice } from '../../helpers/customerTypeHelpers';
import * as css from './Comviq.module.css';

type PropsType = {
  content: Object,
  percent: int,
  timerTextWithSeconds: string,
  completeSubscription: () => void,
};

const ComviqContent = ({ content, percent, timerTextWithSeconds, completeSubscription }: PropsType) => {
  return (
    <>
      {percent < 100 && (
        <>
          <Spinner />
          <h4 className={css.title}>{content.loadingTitle}</h4>
          <p className={css.text}>{content.loadingText}</p>
        </>
      )}
      {percent === 100 && (
        <>
          <Fireworks />
          <h4 className={`${css.title} ${css.success}`}>{content.completeTitle}</h4>
          <p className={css.text}> {content.completeText} </p>
          <p className={css.text}>{timerTextWithSeconds}</p>

          {isAppleDevice() && (
            <Footer className={css.footer} isScrolled={false} isComviq={true}>
              <Button className={css.button} color="pink" primary fluid onClick={completeSubscription}>
                {content.button}
              </Button>
            </Footer>
          )}

        </>
      )}
      <div className={css.progress}>{percent < 100 && <span>{Math.round(percent)}%</span>}</div>
    </>
  );
};

export default forwardRef(ComviqContent);
